import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useParams } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import BeforeWeGetOlder from './pages/BeforeWeGetOlder';
import TechProjects from './pages/TechProjects';
import CVPage from './pages/CVPage';
import TheInBetween from './pages/TheInBetween';
import OrderPage from './pages/order/OrderPage';
import LibraryHome from './components/shared/LibraryHome';
import BookSummary from './components/books/BookSummary';
import { books } from './data/books';
import JoinPage from './pages/JoinPage';
import MyBooks from './pages/MyBooks';
import Journaling from './pages/Journaling';
import BookEvents from './pages/BookEvents';
import EventDetail from './pages/EventDetail';
import ScrollToTop from './components/layout/ScrollToUp';
import Toolkit from './pages/Toolkit';
import Portfolio from './pages/portfolio/Portfolio';
import NotFound from './pages/NotFound';
import JournalTypeDetail from "./pages/JournalTypeDetail";

function BookPage() {
  const { bookSlug } = useParams();
  const book = books.find((b) => b.slug === bookSlug);
  return <BookSummary book={book} />;
}

function AppContent() {
  const location = useLocation();
  const hideHeaderFooter =
    location.pathname === '/cv' ||
    location.pathname === '/portfolio' ||
    location.pathname.startsWith('/journaling/');

  return (
    <>
      {!hideHeaderFooter && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/the-in-between" element={<TheInBetween />} />
        <Route path="/before-we-get-older" element={<BeforeWeGetOlder />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/tech-projects" element={<TechProjects />} />
        <Route path="/cv" element={<CVPage />} />
        <Route path="/library" element={<LibraryHome />} />
        <Route path="/library/:bookSlug" element={<BookPage />} />
        <Route path="/joinpage" element={<JoinPage />} />
        <Route path="/my-books" element={<MyBooks />} />
        <Route path="/order" element={<OrderPage />} />
        <Route path="/order/:bookSlug" element={<OrderPage />} />
        <Route path="/journaling" element={<Journaling />} />
        <Route path="/journaling/:type" element={<JournalTypeDetail />} />
        <Route path="/book-events" element={<BookEvents />} />
        <Route path="/book-events/:eventId" element={<EventDetail />} />
        <Route path="/my-toolkit" element={<Toolkit />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!hideHeaderFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;